<template>
<span class="select-component">
    <select name="type" id="vehicleClassId" v-model="selectedType" data-cf-typeselect @change="selectType">
      <option value="">{{label}}</option>
      <option v-for="type in options" :data-label="type.name" :id="'usageType-' + type.id" :key="type.id" :selected="preselect === type.id" :value="type.id">{{type.name}}</option>
    </select>
  </span>
</template>

<script>
export default {
name: "Type",
  props: {
    label: {
      type: String
    },
    preselect: {
      type: [Number, String]
    },
    options: {
      type: Array
    }
  },
  data() {
    return {
      selectedType: this.preselect
    }
  },

  mounted() {

  },
  methods: {
    selectType() {

      this.$emit("updateType", this.selectedType);

    }
  },
  beforeMount() {
    this.selectType()
  }
}
</script>

<style scoped>

</style>